import React from 'react';
import Time from './Time';

export default ({ event, fixture, state, children }) => {
    const { eventTimes } = state.state;

    const homeClass = event.entry_id === fixture.home_entry.division_entry_id ? 'event--home' : '';
    const eventClass = 'event--' + event.name;
    const eventTime = eventTimes[event.happened_at];

    return (
        <li className="timeline__item">
            <div className={`event ${eventClass} ${homeClass}`}>
                <div className="event__icon">
                    <div className="event__time"><Time time={eventTime}/></div>
                </div>
                {children}
            </div>
        </li>
    );
}
